import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import { Container, msgMainCls, msgInner } from './Layout';
import { Consumer } from '@/store';
import { getLocalText } from '@/utilities/language';
import Ending from '@/components/Ending';
import Loading from '../Loading';
var Submitted = /*#__PURE__*/function (_Component) {
  _inherits(Submitted, _Component);
  function Submitted() {
    _classCallCheck(this, Submitted);
    return _possibleConstructorReturn(this, _getPrototypeOf(Submitted).apply(this, arguments));
  }
  _createClass(Submitted, [{
    key: "renderMessage",
    value: function renderMessage(msg, realPrompt) {
      return React.createElement(Container, {
        className: msgMainCls
      }, React.createElement("div", {
        className: msgInner(window.innerWidth, 0, 'submitted')
      }, msg ? msg.description : React.createElement(Ending, {
        title: getLocalText('error.submitted'),
        type: "warning",
        res: "",
        realPrompt: realPrompt || null,
        finishImgScale: null,
        finishImgUrl: null
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return React.createElement(Consumer, null, function (store) {
        var _store$state = store.state,
          loading = _store$state.loading,
          msg = _store$state.msg,
          realPrompt = _store$state.realPrompt;
        if (loading) return React.createElement(Loading, {
          show: loading
        });
        return React.createElement(React.Fragment, null, React.createElement(Loading, {
          show: loading
        }), _this.renderMessage(msg, realPrompt));
      });
    }
  }]);
  return Submitted;
}(Component);
export { Submitted as default };